export default __webpack_public_path__ + "static/media/envirosensor_lg.7ac5892d.jpg";